export const BARRONS_COLORS = Object.freeze([
  '#00234b', // 0 Dark blue
  '#006be4', // 1 Bright blue
  '#a4e6ff', // 2 Light Blue
  '#179596', // 3 Teal
  '#61d4c0', // 4 Turquoise
  '#9cb123', // 5 Green
  // Greys
  '#aab6b3', // 6 grey
  '#bfc8c6', // 7 gray 75%
  '#d4dad9', // 8 grey 50%
  '#e5e9e8', // 9 grey 30%
  // Accent Colors
  '#f0630c', // 10 bright orange
  '#e8861d', // 11 light orange
  '#f1c254', // 12 yellow
  '#ae2819', // 14 13 dark red
  '#e11500', // 15 bright red
  '#c13fb2', // 16 magenta
  '#ea5f94', // 17 pink
  'rgba(0, 0, 0, 0)', // 16 Transparent
]);

const BARRONS_THEME = Object.freeze({
  name: "Barron's",
  theme: Object.freeze([
    BARRONS_COLORS[0],
    BARRONS_COLORS[1],
    BARRONS_COLORS[2],
    BARRONS_COLORS[3],
    BARRONS_COLORS[4],
    BARRONS_COLORS[5],
  ]),
});

const BARRONS_BLUE_THEME = Object.freeze({
  name: 'Blue theme',
  theme: Object.freeze(['#006be4', '#2a8bf8', '#78b7ff', '#bfddff', '#e6f2ff']),
});

const BARRONS_GREEN_THEME = Object.freeze({
  name: 'Green theme',
  theme: Object.freeze(['#179596', '#39aaab', '#5abbbc', '#92d3d3', '#cceded']),
});

export const BARRONS_COLOR_THEMES = Object.freeze({
  barrons: BARRONS_THEME,
  barrons_green: BARRONS_GREEN_THEME,
  barrons_blue: BARRONS_BLUE_THEME,
});

export const BARRONS_PIE_THEME = Object.freeze([
  ...BARRONS_GREEN_THEME.theme,
  ...BARRONS_BLUE_THEME.theme,
]);

export const BARRONS_PLOT_LINE_COLORS = Object.freeze(['#001E20', '#C6CCD1']);
